export const ROLES = {
  TEACHER: 'invalkracht',
  SCHOOL: 'school',
  ADMIN: 'admin',
} as const;

export type RoleType = (typeof ROLES)[keyof typeof ROLES];
